export const getSessionStorageItem = <T>(key: string, fallback: T): T => {
  const stored = window.sessionStorage.getItem(key);
  if (stored == null) return fallback;
  try {
    return JSON.parse(stored);
  } catch {
    return fallback;
  }
};
